import { Button, Modal } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { CompGridSettingsModalContent } from './CompGridSettingsModalContent.tsx';

export const EstimatesButton = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button
        id="comp-grid-settings"
        variant="secondary"
        size="sm"
        icon="estimated"
        text="Estimates"
        onClick={() => setModalIsOpen(true)}
      />
      <Modal
        title="Settings"
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        size="xl"
        showCloseButton={false}
        closeOnEsc={false}
      >
        {modalIsOpen && <CompGridSettingsModalContent modalOnClose={() => setModalIsOpen(false)} />}
      </Modal>
    </>
  );
};
